module.exports = __webpack_public_path__ + "img/workplace-groups.683e518f.svg";